import { industries } from "./industries";
import { countries } from "./countries";
import { roles } from "./roles";

import { FormStep } from "./types";

const password: FormStep = {
  name: "password",
  title: "Password",
  type: "password",
  required: true,

  end: true,
};

const partialEmail: FormStep = {
  name: "email",
  title: "Email address",
  type: "email",
  required: true,
};

export const generalAuthSteps: FormStep[] = [
  {
    ...partialEmail,
    next: "password",
  },
  {
    ...password,
    previous: "email",
  },
];

export const registerSteps: FormStep[] = [
  {
    ...partialEmail,

    next: "password",
  },
  {
    ...password,

    previous: "email",
    title: "Create password",
    showWith: "termsAndConditions",
  },
];

export const onboardingSteps: FormStep[] = [
  {
    mainTitle: "Company Information",
    name: "company",
    title: "Company Name",
    required: true,
    showStar: true,
    type: "text",

    next: "userDisplayName",
    showWith: "shopUrl",
    autocomplete: "organization",
  },
  {
    name: "shopUrl",
    title: "Website",
    required: true,
    showStar: true,
    type: "url",

    showWith: "industry",
    autocomplete: "url",
  },
  {
    name: "industry",
    title: "Industry",
    required: false,
    type: "select",
    cases: industries,
    enableOther: true,

    showWith: "country",
  },
  {
    name: "country",
    title: "Country",
    required: false,
    type: "select",
    cases: countries,
  },

  {
    mainTitle: "Personal Information",
    name: "userDisplayName",
    title: "My Name",
    required: false,
    type: "text",

    showWith: "position",
    previous: "company",

    end: true,
  },
  {
    name: "position",
    title: "My Role",
    required: false,
    type: "select",
    cases: roles,

    showWith: "phoneNumber",
  },
  {
    name: "phoneNumber",
    title: "My Phone",
    required: false,
    type: "text",
  },
];
